import { environmentConfig } from "@src/appV2/environment";

import { ZENDESK_HELP_CENTER_HOME_PATH } from "./paths";

/**
 * Builds the authenticated Zendesk SSO entry URL. Zendesk validates the JWT,
 * establishes the HC session, then redirects to `return_to` (the HC home).
 */
export function buildZendeskSsoUrl(
  jwt: string,
  returnTo: string = ZENDESK_HELP_CENTER_HOME_PATH
): string {
  const url = new URL(environmentConfig.REACT_APP_ZENDESK_SSO_URL);
  url.searchParams.set("jwt", jwt);
  url.searchParams.set("return_to", returnTo);
  return url.toString();
}
